interface InputProps {
  label?: string;
  value?: any;
  onChange?: (value: any) => void;
  [key: string]: any;
}

const InputComponent = ({
  label,
  value,
  onChange,
  className,
  hideInput = false,
  ...props
}: InputProps) => (
  <div className={hideInput ? 'hidden' : 'block'}>
    {label && (
      <label className="block text-xs text-gray-600 dark:text-gray-300 mb-1">
        {label}
      </label>
    )}
    <input
      className={`w-full px-3 py-2 border border-greyFifty dark:border-gray-600 rounded-lg bg-white dark:bg-gray-700 text-blackFourty dark:greyTen text-sm ${className}`}
      value={value}
      onChange={(e) => onChange?.(e.target.value)}
      {...props}
    />
  </div>
);

export default InputComponent;
